<template>
  <div>
    <el-dialog title="人车信息" center :visible.sync="RCVisible" width='55%' :close-on-click-modal="false" :before-close="RCQuXiao">
        <div class="demo-image__preview" v-if="!lookFlag">
          <div>
            <p>人车信息</p>
            <hr>
            <el-table :data="tableList">
              <el-table-column label="提货车号" prop="outstockPlateNumber" ></el-table-column>
              <el-table-column label="司机姓名" prop="driverName" ></el-table-column>
              <el-table-column label="司机身份证" prop="idNumber" ></el-table-column>
              <el-table-column label="联系电话" prop="telephone" ></el-table-column>
            </el-table>
          </div>
          <div>
            <p>证件信息</p>
            <hr>
            <span v-for="(item, index) in imgList" :key="index">
              <el-image
              :preview-src-list="getSrcList(index,imgList)"
              fit="cover"
              :src="item"
              style="width:200px;height:180px;margin:0 20px 20px;">
              </el-image>
            </span>
            <span v-if="imgList.length==0">暂无信息</span>
          </div>
        </div>
        <span v-if="lookFlag">暂无信息</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="RCQuXiao">关 闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { findDriverByIdentityNo, findVhcByVhcNo } from '@/api/wms-stock'
export default {
  name: 'rcDialog',
  data () {
    return {
      lookFlag: false,
      imgList: [],
      tableList: [{}]
    }
  },
  props: {
    RCVisible: {
      type: Boolean,
      default: false
    },
    identityNo: {
      type: String
    },
    vhcNo: {
      type: String
    },
    driverName: {
      type: String
    },
    telephone: {
      type: String
    }
  },
  mounted () {
    this.getInfos()
    this.tableList[0].outstockPlateNumber = this.vhcNo
    this.tableList[0].driverName = this.driverName
    this.tableList[0].telephone = this.telephone
    this.tableList[0].idNumber = this.identityNo
  },
  methods: {
    RCQuXiao () {
      this.$emit('update:RCVisible', false)
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      // const list = arr.map(item => item.imgUrl)
      return arr.slice(index).concat(arr.slice(0, index))
    },
    getInfos () {
      const that = this
      findDriverByIdentityNo({ identityNo: this.identityNo })
        .then(res => {
          console.log(res)
          if (res != null) {
            const dataBackups = JSON.parse(res)
            that.imgList.push(dataBackups.appendix1Url)
            that.imgList.push(dataBackups.appendix2Url)
            that.imgList.push(dataBackups.identityPhoto1Url)
            that.imgList.push(dataBackups.identityPhoto2Url)
            that.imgList.push(dataBackups.qualificationPhotoUrl)
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      findVhcByVhcNo({ vhcNo: this.vhcNo })
        .then(res => {
          console.log(res)
          if(res != null){
            const dataBackups = JSON.parse(res)
            that.imgList.push(dataBackups.transportPhotoUrl)
            that.imgList.push(dataBackups.vhcLicense1Url)
            that.imgList.push(dataBackups.vhcLicense2Url)
            that.imgList.push(dataBackups.vhcPhoto1Url)
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    }
  }

}
</script>

<style>

</style>
